// extracted by mini-css-extract-plugin
export default {"chart":"DataChart_chart__JMy8A"};